import { render, staticRenderFns } from "./OrderAddressDialog.vue?vue&type=template&id=751ddb3d&"
import script from "./OrderAddressDialog.vue?vue&type=script&lang=js&"
export * from "./OrderAddressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports